import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';

import initialState from './initialState';
import reducer from './reducer';
import saga from './sagas';
import trackingMiddleware from './tracking-middleware';

// Memoize the store in global.__cartStore so that cart components can be imported by other apps without creating more
// instances of the store.
if (!global.__cartStore) {
  const composeEnhancers =
    (typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;
  const sagaMiddleware = createSagaMiddleware();

  global.__cartStore =
    global.__cartStore ||
    createStore(
      reducer,
      initialState,
      composeEnhancers(applyMiddleware(sagaMiddleware, trackingMiddleware))
    );

  sagaMiddleware.run(saga);
}

export default global.__cartStore;
